<template>
  <div class="row">
    <div class="col-12">
      <div class="card card-bordered px-4 pt-4 mb-4">
        <div class="row">
          <div class="col-auto mb-4">
            <div class="fv-row">
              <select
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                title="Selecione a condição à ser filtrada
Todos: todos os filtros do grupo devem ser atendidos
Qualquer: pelo menos um filtro do grupo deve ser atendido"
                class="form-select form-select-sm mb-0"
                data-placeholder="Selecione uma opção"
                v-model="this.regraFiltro.condicao"
              >
                <option value="and">Todos</option>
                <option value="or">Qualquer</option>
              </select>
            </div>
          </div>
          <div class="col-auto mb-4">
            <div class="fv-row">
              <button
                @click="this.adicionarRegra()"
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                title="Adicionar regra"
                class="d-flex justify-content-center align-items-center btn-bg-light btn btn-sm btn-active-light-primary svg-icon-white px-2 pb-2 pe-4"
              >
                <i class="la la-plus ms-1 fs-2"></i>Regra
              </button>
            </div>
          </div>
          <div class="col-auto mb-4">
            <div class="fv-row">
              <button
                @click="this.adicionarGrupo()"
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                title="Adicionar grupo"
                class="d-flex justify-content-center align-items-center btn-bg-light btn btn-sm btn-active-light-success svg-icon-white px-2 pb-2 pe-4"
              >
                <i class="la la-plus ms-1 fs-2"></i>Grupo
              </button>
            </div>
          </div>
          <div
            v-if="!this.showRemove"
            class="d-flex align-items-center col-auto mb-4"
          >
            <span class="badge badge-light-success text-primary fs-7">{{
              descricaoFiltro
                ? "Filtrando por: " + descricaoFiltro
                : "Novo Filtro"
            }}</span>
          </div>
          <div v-if="this.showRemove" class="col-auto mb-4">
            <div class="fv-row">
              <button
                @click="this.$emit(`removerGrupo`)"
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                title="Remover grupo"
                class="d-flex justify-content-center align-items-center btn-bg-light btn btn-sm btn-active-light-danger svg-icon-white px-2 pb-2"
              >
                <i class="la la-trash-o ms-1 fs-2"></i>
              </button>
            </div>
          </div>
        </div>
        <div
          class="ms-md-8"
          v-for="(regra, index) in this.regraFiltro.regras"
          :key="index"
        >
          <GroupQueryBuilder
            v-if="regra.condicao"
            :regra="regra"
            :model="this.model"
            :operadores="this.operadores"
            @removerGrupo="this.removerGrupo(index)"
          />
          <DynamicQueryBuilder
            v-else
            :regra="regra"
            :model="this.model"
            :operadores="this.operadores"
            @removerRegra="this.removerRegra(index)"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DynamicQueryBuilder from "@/components/query-builder/DynamicQueryBuilder.vue";

export default {
  name: "GroupQueryBuilder",
  emits: ["removerGrupo"],
  components: {
    DynamicQueryBuilder,
  },
  props: {
    regra: { type: Object, required: true },
    model: { type: Object, required: true },
    operadores: { type: Object, required: true },
    showRemove: { type: Boolean, required: false, default: true },
    descricaoFiltro: { type: String, required: false, default: "" },
  },
  methods: {
    adicionarRegra() {
      this.regraFiltro.regras.push({
        campo: "",
        operador: "",
        tipo: "",
        valor: "",
        valor_entre: "",
        utc: false,
      });
    },
    adicionarGrupo() {
      this.regraFiltro.regras.push({
        condicao: "and",
        regras: [],
      });
    },
    removerRegra(index) {
      this.regraFiltro.regras.splice(index, 1);
    },
    removerGrupo(index) {
      this.regraFiltro.regras.splice(index, 1);
    },
  },
  watch: {
    regra: {
      handler(newRegra) {
        this.regraFiltro = this.regra;
      },
      deep: true,
    },
  },
  async mounted() {
    this.regraFiltro = this.regra;
  },
  data() {
    return {
      regraFiltro: {
        condicao: "and",
        regras: [],
      },
    };
  },
};
</script>

<style></style>
